import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n';
import echarts from './utils/echarts.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/el-element.css'
import i18n from './common/lang';
import Vant from 'vant';
import 'vant/lib/index.css';
import { Step, Steps } from 'vant';
import request from './utils/request';
import './assets/theme.css'; // 引入主题样式
import Toast from './components/Toast'; // 引入自定义Toast组件

Vue.use(Step);
Vue.use(Steps);
Vue.use(Toast); // 注册Toast插件

Vue.use(ElementUI);
Vue.use(Vant);
// import enLocale from 'element-ui/lib/locale/lang/en';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = request;
Vue.config.productionTip = false

// 全局样式：确保Element UI消息组件始终在最顶层
const style = document.createElement('style');
style.textContent = `
  .el-message,
  .el-message--error,
  .el-message--success,
  .el-message--warning,
  .el-message--info {
    z-index: 99999 !important;
    position: fixed !important;
  }
  
  .el-message-box__wrapper {
    z-index: 99998 !important;
    position: fixed !important;
  }
  
  .el-message-box {
    z-index: 99998 !important;
  }
`;
document.head.appendChild(style);

// 夜间模式初始化已移至 App.vue 的 mounted 钩子中
// 这样可以根据设备类型（PC/移动端）使用不同的 localStorage key

/** 国际化 **/
// Vue.use(VueI18n);
// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n.t(key, value)
// });
// const i18n = new VueI18n({
//   locale: 'en',
//   messages: {
//     'zh': Object.assign(require('@/common/lang/zh'), zhLocale),
//     'en': Object.assign(require('@/common/lang/en'), enLocale),
//   }
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')